import React, { Component } from 'react';
import jquery from 'jquery';
import { message, Modal } from 'antd';
import EditableCell from '../common/tableCell/TableCell';
import TableC from '../basicElement/TableC';
import $ from '../../common/AjaxRequest';
import ConfigColumn from './ConfigColumn';
import API_URL from '../../common/url';
import CrfHistory from './crfHistory';
import CrfAgain from './crfAgain';
import moment from 'moment';
import './style/list.less';

const dateFormat = 'YYYY-MM-DD';
const dateFormatHour = 'YYYY-MM-DD HH';
// 按项目缓存 getInvCreateTimeVisit 的判断结果，避免组件多次挂载/父组件多次重渲染导致重复请求
const invCreateTimeVisitCache = {};

class CrfTable extends Component {
	state = {
		dataSource: [],
		columns: [],
		count: 0,
		loading: false,
		tableColumns: [],
		requiredMap: new Map(),
		moduleDefineCode: null,
		moduleDefineId: null,
		maxDate: '',
		isSwitchVisitGroupingSimple: false,
	}

	queryEffectiveDate = () => {
		$.sendRequest({
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ maxDate: res.date });
            }
        });
    }

    queryInvCreateTimeVisit = () => {
		const invId = sessionStorage.invId;
		// 同一项目本次页面加载内只请求一次，后续直接使用缓存结果（Tab 切换/父组件重渲染会重复触发）
		if (invCreateTimeVisitCache[invId] !== undefined) {
			this.setState({ isSwitchVisitGroupingSimple: invCreateTimeVisitCache[invId] });
			return;
		}
		this.setState({ isSwitchVisitGroupingSimple: false });
		$.sendRequest({
			method: 'POST',
			url: API_URL.plan.getInvCreateTimeVisit,
			data: { investigationId: invId },
			dataType: 'json',
			doneResult: res => {
				const { invCreateTime, invCreateTimeVisit } = res;
				// invCreateTime / invCreateTimeVisit 均为 yyyy-MM-dd，字符串比较等价于时间比较
				const isSimple = !!(invCreateTime && invCreateTimeVisit && invCreateTime > invCreateTimeVisit);
				invCreateTimeVisitCache[invId] = isSimple;
				this.setState({ isSwitchVisitGroupingSimple: isSimple });
			},
		});
	}

	getSaveParam = (rowDataOriginal) => {
		const rowData = JSON.parse(JSON.stringify(rowDataOriginal));
		const paramsObj = {
			newParams: '',
			postObj: {}
		};
		let indicatorCount = -1;
		const indicatorRowCount = {};
		const rowIndexObj = {};
		let newParams = ``;
		newParams += `?`;
		const { moduleDefineCode: userModuleDefineCode } = this.state;
		for (let key in rowData) {
			if (typeof rowData[key] === "object" && rowData[key] !== null) {
				if (key === (rowData[key].moduleDefineCode + '_' + (rowData[key].rowNum || 1)) || userModuleDefineCode === key) {
					const { moduleDefineCode } = rowData[key];
					const rowCount = indicatorRowCount[moduleDefineCode];
					let prevModuleDefineCode;
					if (rowData[moduleDefineCode]) {
						if (Array.isArray(rowData[moduleDefineCode])) {
							prevModuleDefineCode = rowData[moduleDefineCode];
						} else {
							prevModuleDefineCode = [rowData[moduleDefineCode]];
						}
					} else {
						prevModuleDefineCode = [];
					}
					const prevData = prevModuleDefineCode.find(i => i.rowNum == rowData[key].rowNum) || null;
					if (!prevData && rowData[key].value) {
						rowData[key]["operationType"] = 'INSERT';
					} else if (prevData && prevData.value && !rowData[key].value) {
						rowData[key]["operationType"] = 'DELETE';
					} else if (prevData && rowData[key].value) { 
						//  原来的判断条件 “prevData && prevData.value && rowData[key].value”
						//  prevData.value为修改前的值；rowData[key].value为修改后的值。若后台传的prevData.value为空，则不会给"operationType"赋值，从而不会把修改后的值传给后台
						if (prevData.value != rowData[key].value || prevData.comment != rowData[key].comment) {
							rowData[key]["operationType"] = 'UPDATE';
						}
					}
					if (userModuleDefineCode === key && prevData && !rowData[userModuleDefineCode + '_' + prevData.rowNum].value && prevData.value) {
						rowData[key]["operationType"] = 'INSERT';
					}
					if (rowData[key].operationType) {
						if (rowCount >= 0) {
							indicatorRowCount[rowData[key].moduleDefineCode] = indicatorRowCount[rowData[key].moduleDefineCode] + 1;
						} else {
							indicatorRowCount[rowData[key].moduleDefineCode] = 0;
							indicatorCount++;
							rowIndexObj[rowData[key].moduleDefineCode] = indicatorCount;
						}
						for (const keySec in rowData[key]) {
							if (keySec == "rowNum" && rowData[key]["realRowNum"]) {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key]["realRowNum"];
							} else {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key][keySec] ? rowData[key][keySec] : '';
							}
						}
						paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicatorCode`] = rowData[key].moduleDefineCode;
					}
				}
			} else {
				newParams += '&' + key + '=' + rowData[key];
			}
		}
		paramsObj.newParams = newParams;
		return paramsObj;
	}

	verify = (record) => {
		const { typeName, tableColumns, isUnBlind, relateCenter } = this.props;
		const { requiredMap } = this.state;
		const related = record.origin === 'RELATED' || (isUnBlind && relateCenter);
		for (let [key, value] of requiredMap) {
			const name = requiredMap.get(key);
			const field = record[key];
			if (!field) {
				if (typeName === 'Type_Visit') {
					if (name == "筛选编号") {
						Modal.error({ title: `请选择筛选编号` });
						return;
					} else if (!(related && (name == "患者状态" || name == "是否最后一个病例完成试验"))) {
						Modal.error({ title: `请输入${name}` });
						return;
					}
				} else if (typeName === 'Type_SAE') {
					if (!(name == "SAE结束时间" || name == "与试验药物是否相关" || name == "SAE结局")) {
						Modal.error({ title: `请输入${name}` });
						return;
					}
				} else {
					Modal.error({ title: `请输入${name}` });
					return;
				}
			} else if (field) {
				const noValue = field.value == "" || field.value == undefined;
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
					if (field.editable !== 0) {
						if (noValue) {
							if (typeName == 'Type_Visit') {
								if (name == "筛选编号") {
									Modal.error({ title: !related ? '请选择筛选编号' : '请输入筛选编号' });
									return;
								} else if (
									!(related && (name == "患者编号" || name == "患者状态" || name == "完成试验时间" || name == "是否最后一个病例完成试验"))
								) {
									Modal.error({ title: `请输入${name}` });
									return;
								}
							} else {
								Modal.error({ title: `请输入${name}` });
								return;
							}
						}
					}
				} else if (typeName === 'Type_SAE') {
					if (name == "SAE跟进情况" && field.value == "结束") {
						for (let [key, value] of requiredMap) {
							const name = requiredMap.get(key);
							const field = record[key];
							const noValue = field.value == "" || field.value == undefined;
							if (!field && (name == "SAE结束时间" || name == "与试验药物是否相关" || name == "SAE结局")) {
								Modal.error({ title: `请输入${name}` });
								return;
							} else if (field && noValue) {
								Modal.error({ title: `请输入${name}` });
								return;
							}
						}
					} else if (
						!(name == "SAE结束时间" || name == "与试验药物是否相关" || name == "SAE结局") &&
						(noValue)
					) {
						Modal.error({ title: `请输入${name}` });
						return;
					}
				} else if (noValue) {
					Modal.error({ title: `请输入${name}` });
					return;
				}
			}
		}
		if (!(record.key).endsWith('new5efk') && typeName == 'Type_Filter') {
			this.checkCanAddFilterRecord(record);
		} else if (typeName == 'Type_Violation') {
			let violationCode;
			let violationCodeRowNum;
			let isBelongImportantEventCode;
			let eventCodeRowNum;
			tableColumns.forEach(column => {
				const { moduleDefineName, moduleDefineCode, rowNum } = column;
				if (moduleDefineName === '方案违背等级') {
					violationCode = moduleDefineCode;
					violationCodeRowNum = rowNum;
				} else if (moduleDefineName === '是否属于重大事件') {
					isBelongImportantEventCode = moduleDefineCode;
					eventCodeRowNum = rowNum;
				}
			});
			if ((record[violationCode]
				&& record[violationCode][0]['value'] === '重大'
				&& record[isBelongImportantEventCode]
				&& record[isBelongImportantEventCode][0]['value'] === '是')
				&& (record[`${violationCode}_${violationCodeRowNum}`]['value'] !== '重大'
				|| record[`${isBelongImportantEventCode}_${eventCodeRowNum}`]['value'] !== '是')) {
				Modal.confirm({
					iconType: 'question-circle',
					title: <div style={{ marginLeft: 42 }}>修改后，本条方案违背不再满足重大事件的条件，导致由本条方案违背产生的重大事件不再显示，确认保存修改？</div>,
					onOk: () => this.save(record),
				});
			} else {
				this.save(record);
			}
		} else {
			this.save(record);
		}
	}

	checkCanAddFilterRecord = (record) => {
		this.setState({ loading: true });
		$.sendRequest({
			url: API_URL.execute.checkCanAddFilterRecord,
			data: { investigationSiteId: record ? record.siteId : sessionStorage.siteId },
			dataType: 'json',
			doneResult: () => {
				this.setState({ loading: false });
				record ? this.save(record) : this.handleAddRecord();
			},
			errorResult: () => {
				this.setState({ loading: false });
			},
		});
	}

	save = (record, flag) => {
		const { isRelative, currentGroup: { visitGroupingId }, typeName } = this.props;
		const { patientStatus } = sessionStorage;
		const parsePatientStatus = patientStatus ? JSON.parse(patientStatus) : {};
		const { quitTime, quitComment } = parsePatientStatus;

		const paramsObj = this.getSaveParam(record);
		this.setState({ loading: true });
		$.sendRequest({
			url: `${API_URL.execute.save}${paramsObj.newParams}`,
			data: {
				...paramsObj.postObj,
				typeName: (typeName == 'Type_Violation' && !isRelative) ? 'Type_Nopatient_Violation' : typeName,
				visitGroupingId,
				isCheck: flag !== '' ? 1 : flag,
				quitTime,
				quitComment
			},
			method: 'post',
			dataType: 'json',
			doneResult: data => {
				if (!data.confirmError) {
					this.setState({ loading: false }, () => {
						const { needTransfer = false, otherVisitGroupingId } = this.state;
						if (needTransfer) {
							this.transferData({ visitGroupingId: otherVisitGroupingId, patientId: (data.patientUserId || record.patientUserId) });
						} else {
							this.props.loadData();
						}
					});
					message.success('保存成功');
					sessionStorage.removeItem('patientStatus');
				} else {
					Modal.confirm({
						iconType: 'exclamation-circle',
						title: <div style={{ marginLeft: 42 }}>该患者（访视）已被引用在工时记录中，删除此记录将同时影响对应工时的患者（访视）备注，是否确认删除?</div>,
						onOk: this.save(record, ''),
						onCancel: () => {
							this.setState({ loading: false }, () => {
								this.props.loadData();
							});
						}
					});
				}
			},
			errorResult: () => {
				this.setState({ loading: false });
			},
		});
	}

	transferData = (params) => {
		const { visitGroupingId, patientId } = params;
		this.setState({ loading: true });
		$.sendRequest({
			url: API_URL.execute.changePatientVisitGroupingId,
			data: {
				patientId,
				visitGroupingId,
			},
			dataType: 'json',
			doneResult: res => {
				message.success(res.success);
				this.setState({
					loading: false,
					needTransfer: false,
				}, () => {
					this.props.changeTabs(visitGroupingId);
				});
			},
			errorResult: () => {
				this.setState({ loading: false });
			},
		});
	}

	handleDelete = (record, index) => {
		const { typeName, tableColumns } = this.props;
		if (typeName === 'Type_Violation') {
			let violationCode;
			let isBelongImportantEventCode;
			tableColumns.forEach(column => {
				const { moduleDefineName, moduleDefineCode } = column;
				if (moduleDefineName === '方案违背等级') {
					violationCode = moduleDefineCode;
				} else if (moduleDefineName === '是否属于重大事件') {
					isBelongImportantEventCode = moduleDefineCode;
				}
			});
			if (record[violationCode]
				&& record[violationCode][0]['value'] === '重大'
				&& record[isBelongImportantEventCode]
				&& record[isBelongImportantEventCode][0]['value'] === '是') {
				Modal.confirm({
					iconType: 'question-circle',
					title: '删除本条方案违背，会导致由本条方案违背产生的重大事件同步删除，是否确认删除？',
					onOk: () => this.rowDelete(record, index),
				});
			} else {
				this.showConfirm(record, index, false);
			}
		} else if (typeName === 'Type_Visit') {
			this.showConfirm(record, index, true);
		} else {
			this.showConfirm(record, index, false);
		}
	}

	showConfirm = (record, index, validate) => {
		const { isUnBlind } = this.props;
		Modal.confirm({
			iconType: 'exclamation-circle',
			title: '确定要删除吗?',
			content: (validate && isUnBlind) ? '删除访视记录，会同步删除对应的退出记录/方案违背记录' : '',
			onOk: () => validate ? this.preDelete(record, index) : this.rowDelete(record, index),
		});
	}

	preDelete = (record, index) => {
		const { patientUserId } = record;
		$.sendRequest({
			url: API_URL.execute.deleteCrfRowDataCheck,
			data: { patientUserId },
			dataType: 'json',
			doneResult: res => {
				if (res.data) {
					Modal.confirm({
						iconType: 'exclamation-circle',
						title: <div style={{ marginLeft: 42 }}>该患者（访视）已被引用在工时记录中，删除此记录将同时影响对应工时的患者（访视）备注，是否确认删除?</div>,
						onOk: () => this.rowDelete(record, index),
					});
				} else {
					this.rowDelete(record, index);
				}
			},
		});
	}

	rowDelete = (record, index) => {
		const { isRelative, currentGroup: { visitGroupingId }, typeName } = this.props;
		if (record.patientUserId == -1 || record.rowNum == undefined) {
			const { dataSource } = this.state;
			dataSource.splice(index, 1);
			this.setState({ dataSource }, () => {
				if (dataSource.length == 0) {
					const { tableColumns } = this.state;
					const { columns } = this.convertColumns(tableColumns);
					this.setState({ columns });
				}
			});
			message.success('删除成功');
		} else {
			this.setState({ loading: true });
			$.sendRequest({
				url: API_URL.execute.deleteCrfRowData,
				data: {
					typeName: (typeName === 'Type_Violation' && !isRelative) ? 'Type_Nopatient_Violation' : typeName,
					visitGroupingId,
					patientUserId: record.patientUserId,
					rowNum: record.rowNum,
					origin: record.origin,
				},
				dataType: 'json',
				doneResult: () => {
					message.success('删除成功');
					this.setState({ loading: false }, () => {
						this.props.loadData();
					});
				},
				errorResult: () => {
					this.setState({ loading: false });
				},
			});
		}
	}

	getVisitDate = (referencedActualDate, referencedActualCode, rowIndex, criteriaDefineId, tableColumn, record) => {
		const { prevReferCodes = {} } = this.state;
		let params = {
			referencedActualCode
		};
		params.referencedActualDate = referencedActualDate == '' ? '' : referencedActualDate;
		const { rowNums = [], moduleDefineCode } = tableColumn;
		const { currentGroup: { visitGroupingId } } = this.props;
		rowNums && rowNums.map((key, index) => {
			let value = "";
			const dataIndex = moduleDefineCode + "_" + key;
			if (referencedActualCode == dataIndex) {
				value = referencedActualDate;
			} else if (record[dataIndex] && record[dataIndex].value) {
				value = record[dataIndex].value;
			}
			params[`keyValues[${index}].key`] = key;
			params[`keyValues[${index}].value`] = value;
		})
		if (visitGroupingId) {
			params.visitGroupingId = visitGroupingId;
			params.patientId = record.patientUserId;
		}
		//记录哪些时间指标已经请求过了
		prevReferCodes[referencedActualCode] = false;
		this.setState({
			loading: true,
			prevReferCodes,
		});
		const options = {
			url: API_URL.execute.getPlanVisitDate,
			data: { ...params },
			dataType: 'json',
			doneResult: data => {
				const { prevReferCodes } = this.state;
				const list = data.datas || [];
				//记录这个指标已经请求过了
				prevReferCodes[referencedActualCode] = true;

				list.forEach((value, index) => {
					const newTableColumn = {
						...tableColumn,
						moduleDefineCode: value[2],
						rowNum: value[3],
					}
					//如果返回了映射的时间指标的值，需要对此时间指标再进行getPlanVisitDate请求
					if (value[1]) {
						//如果时间指标没有请求过，要请求
						if (prevReferCodes[value[0]] === undefined) {
							this.onCellChange(rowIndex, value[0], criteriaDefineId, true, record, newTableColumn)(value[1], 'value');
						} else {
							//如果时间指标请求过了，那么不需要请求，也不需要赋值了
							//this.onCellChange(rowIndex, value[0], criteriaDefineId, undefined, record, newTableColumn)(value[1], 'value');
						}
					} else {
						//如果没有返回映射的时间指标，不请求了
						this.onCellChange(rowIndex, value[0], criteriaDefineId, undefined, undefined, newTableColumn)("", 'value');
					}
				});

				if (Object.values(prevReferCodes).every(i => i)) {
					this.setState({ 
						loading: false,
						prevReferCodes: {},
					});
				}
			},
		};
		$.sendRequest(options);
	}

	configColumn = () => {
		const { currentGroup: { visitGroupingId }, tableColumns } = this.props;
		this.configColumnRef.show({ visitGroupingId }, tableColumns);
	}

	convertColumns = (tableColumns) => {
		const columns = [];
		const { maxDate, dataSource,isFilterProcess } = this.state;
		const { typeName, isUnBlind, relateCenter, visitGroup, currentGroup, isRelative } = this.props;
		const dataEmpty = dataSource.length === 0;
		const requiredMap = new Map();
		const { curRole } = sessionStorage;
		const isPA = curRole == 'PA';
        const isPM = curRole == 'PM';
        const isCRC = curRole == 'CRC';
		const isPA_PM_CRC = isPA || isPM || isCRC;
		const canEdit = isPA_PM_CRC || (!isPA_PM_CRC && (typeName == 'Type_Filter' || typeName == 'Type_Pre_Filter'));

		const newTableColums = [];
		tableColumns.forEach(column => {
			const { rowNum, isShow, moduleDefineCode, moduleDefineName, moduleDefineIsRequired } = column;
			if (typeName == 'Type_Filter' || typeName == 'Type_Visit') {
				if (isShow) {
					newTableColums.push(column);
				}
			} else {
				newTableColums.push(column);
			}
			if (moduleDefineName !== '操作' || moduleDefineName !== '录入者') {
				if (
					moduleDefineIsRequired == 1 ||
					(moduleDefineIsRequired == 0 && (moduleDefineName == 'SAE结束时间' || moduleDefineName == '与试验药物是否相关' || moduleDefineName == 'SAE结局')) ||
					(typeName == 'Type_Visit' && isUnBlind && !relateCenter && moduleDefineName == '患者编号')
				) {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				}
			}
		});

		newTableColums.forEach((tableColumn, columnIndex) => {
			let title = tableColumn.moduleDefineName || '',
				type = tableColumn.criteriaDataType,
				webType = tableColumn.projectDefineWebType,
				dataIndex = tableColumn.moduleDefineCode == "op" ? tableColumn.moduleDefineCode : tableColumn.moduleDefineCode + "_" + tableColumn.rowNum,
				criteriaDefineId = tableColumn.criteriaDefineId,
				canAddComment = tableColumn.canAddComment,
				column = {
					visitTypeName: tableColumn.visitTypeName,
					visitTypeNameShow: tableColumn.visitTypeNameShow,
					width: 160,
				},
				config = {
					isEdit: true,
					comment: {
						iscomment: false,
						//value: comment,
					},
					colorClass: "normal",
					type: {
						type: type,
						webType: webType,
						moduleDefineConstraintValue: tableColumn.moduleDefineConstraintValue,
						formatValue: tableColumn.formatValue
					},
					...tableColumn
				};
			if (title == '录入者') {
				column.width = 80;
			}
			if (columnIndex === 0) {
				column.fixed = 'left';
			}
			if (webType) {
				column.dataIndex = dataIndex;
			}
			column.type = type;
			column.webType = webType;
			if (title == '患者编号' || title == '预筛号' || title == '筛选编号') {
				if(title == '预筛号' || (typeName == 'Type_Filter' && title == '筛选编号')){
					column.sorter = true;
				}
			}
			if (tableColumn.canAddComment == 1) {
				config.comment.iscomment = true;
			}
			if (title == '筛选编号') {
					column.title = <span>筛选编号</span>;
			} else {
				column.title = (
					<div style={{ display: "inline-block" }}>
						{ title.split("\r\n").map(i => <p>{i}</p>)}
					</div>
				);
			}
			if (dataIndex !== "op" && title != '录入者' && canAddComment != 1) {
				const isFirst = columnIndex == 0; //当第一列且有加号的时候特殊处理
				column.render = (text, record, index) => {
					const { origin, editable, children, patientUserId } = record;
					config.isEdit = true; //放弃使用config中的isEdit判断是否可编辑，因为config外部引用问题有bug。
					let isEdit = true;
					if (text || record) {
						if (editable == 0) {
							isEdit = false;
						}
					}
					if (typeName == 'Type_Visit') {
						if (
							(!isUnBlind && isFilterProcess == 0 && (title == '筛选编号' || title == '筛选时间')) ||
							(!isUnBlind && isFilterProcess == 1 && (title == '患者编号' || title == '随机(入组)时间')) ||
							(
								((isUnBlind && relateCenter) || origin === 'RELATED') &&
								(
									title == '患者编号' ||
									title == '知情同意时间' ||
									title == '筛选时间' ||
									title == '随机(入组)时间' ||
									title == '访视分组' ||
									title == '患者状态' ||
									title == '完成试验时间' ||
									title == '是否最后一个病例完成试验'
								)
							)
						) {
							isEdit = false;
						}
					} else if (typeName == 'Type_Filter') {
						//开启筛选流程，筛选的字段可编辑性走原来逻辑
						if (isFilterProcess == 1) {
							if(title == '是否第一个受试者入组') {
								isEdit = false;
							}
						} else{
							//不开启筛选流程，除了“是否最后一个受试者入组”外，其他所有字段不可编辑（为锁定状态）；
							if(title == '是否最后一个受试者入组') {
								isEdit = true;
							} else{
								isEdit = false;
							}
						}
						
					} else if (typeName == 'Type_SAE') {
						if(title == '患者编号') {
							isEdit = false;
						}
						if(title == '筛选编号') {
							if (patientUserId == -1) {
								isEdit = true;
							} else {
								isEdit = false;
							}
							
						}
					}
					let special = false;
					if (typeName == 'Type_Visit' && (title == '筛选时间' || title == '随机(入组)时间')) {
						special = true;
					}
					return (
						!dataEmpty &&
						<div style={isFirst && !!(children || []).length ? { paddingLeft: 20 } : {}}>
							<EditableCell
								cellValue={text}
								onChange={this.onCellChange(index, dataIndex, criteriaDefineId, special, record, tableColumn)}
								onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
								config={config}
								isEdit={isEdit}
								visitGroup={visitGroup}
								currentGroup={currentGroup}
								isRelative={isRelative}
								typeName={typeName}
								maxDate={maxDate}
								record={record}
								index={index}
								isUnBlind={isUnBlind}
								relateCenter={relateCenter}
								isSwitchVisitGroupingSimple={this.state.isSwitchVisitGroupingSimple}
							/>
						</div>
					);
				}

				columns.push(column);
			} else if (title == '录入者' && canAddComment != 1) {
				const { moduleDefineCode, moduleDefineId } = tableColumn;
				this.setState({
					moduleDefineCode,
					moduleDefineId
				});
				column.render = text => text ? <div className="editable-cell">{text.value}</div> : null;
				columns.push(column);
			} else if (canAddComment == 1) {
				column.render = (text, record, index) => {
					let isEdit = true;
					config.isEdit = true;
					if (text || record) {
						if (record.editable === 0) {
							isEdit = false;
						}
					}
					return (
						!dataEmpty &&
						<EditableCell
							cellValue={text}
							onChange={this.onCellChange(index, dataIndex, criteriaDefineId, true, record, tableColumn)}
							onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
							config={config}
							isEdit={isEdit}
							typeName={typeName}
							maxDate={maxDate}
							record={record}
							index={index}
							isSwitchVisitGroupingSimple={this.state.isSwitchVisitGroupingSimple}
						/>
					);
				}
				columns.push(column);
			}
		});
		this.setState({ requiredMap });

		if (canEdit) {
			const opColumn = {
				title: '操作',
				dataIndex: 'operate',
				key: 'operate',
				fixed: 'right',
				width: 120,
				render: (text, record, index) => {
					if (record.children && record.children.length > 0) {
						return <div className="editable-cell"> - </div>;
					} else {
						return (
							!dataEmpty &&
							<div className="editable-cell">
								{
									isPA_PM_CRC &&
									(
										record.isSave ?
											<a onClick={() => this.props.canEditByInvStatus(() => this.verify(record))}>保存</a>
										:
											<a disabled={true}>保存</a>
									)
								}
								{
									(isCRC ||isPM) && !(typeName === 'Type_Filter' && isFilterProcess == 0) &&
									<span>
										<span className="ant-divider"></span>
										{
											(record.deleteable == 1 && !(typeName === 'Type_Drop' && record.origin === 'RELATED')) ?
												<a onClick={() => this.props.canEditByInvStatus(() => this.handleDelete(record, index))}>删除</a>
											:
												<a disabled={true}>删除</a>
										}
									</span>
								}
								{
									isCRC && (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') && !(typeName === 'Type_Filter' && isFilterProcess == 0) &&
									<span>
										<span className="ant-divider"></span>
										{
											record.isAgain ?
												<a onClick={() => this.props.canEditByInvStatus(() => this.showCrfAgain(record))}>{`再次${typeName == 'Type_Pre_Filter' ? '预筛' : '筛选'}`}</a>
											:
												<a disabled={true}>{`再次${typeName == 'Type_Pre_Filter' ? '预筛' : '筛选'}`}</a>
										}
									</span>
								}
								{
									(typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') && !(typeName === 'Type_Filter' && isFilterProcess == 0) &&
									<span>
										{
											isPA_PM_CRC &&
											<span className="ant-divider"></span>
										}
										{
											record.isRecordList ?
												<a onClick={() => this.props.canEditByInvStatus(() => this.showCrfHistory(record.patientUserId))}>{`${typeName == 'Type_Pre_Filter' ? '预筛' : '筛选'}历史`}</a>
											:
												<a disabled={true}>{`${typeName == 'Type_Pre_Filter' ? '预筛' : '筛选'}历史`}</a>
										}
									</span>
								}
							</div>
						);
					}
				},
			};
			columns.push(opColumn);
		}

		const params = {};
		const parentColumn = [];
		columns.map((column) => {
			if (column.visitTypeNameShow) {
				if (Object.keys(params).length > 0) {
					for (let key in params) {
						if (key != column.visitTypeNameShow) {
							params[column.visitTypeNameShow] = column.visitTypeNameShow.split(',');
						}
					}
				} else {
					params[column.visitTypeNameShow] = column.visitTypeNameShow.split(',');
				}
			}
		});

		if (Object.keys(params).length > 0) {
			for (let key in params) {
				let isExist = false;
				const typeColumn = {};
				params[key].map((item, index) => {
					if (parentColumn.length > 0) {
						parentColumn.map((parItem, parIndex) => {
							if (parItem.title == params[key][0]) {
								isExist = true;
							}
						});
						
						if (isExist) {
							parentColumn.map((parItem, parIndex) => {
								if (parItem.title == params[key][0]) {
									if (index == 0) {
										columns.map((column) => {
											if (column.visitTypeNameShow == `${params[key][0]}`) {
												parItem.children.push(column);
											}
										});
									} else if (index == 1) {
										let flag = false;
	
										parItem.children.map((innerItem, innerIndex) => {
											if (innerItem.title == params[key][1]) {
												flag = true;
												columns.map((column) => {
													if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
														innerItem.children.push(column);
													}
												});
											}
										});
	
										if (!flag) {
											const obj = {};
											obj.title = item;
											obj.children = [];
	
											columns.map((column) => {
												if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
													obj.children.push(column);
												}
											});
											parItem.children.push(obj);
										}
									} else if (index == 2) {
										const obj = {};
										obj.title = item;
										obj.children = [];
										columns.map((column) => {
											if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
												obj.children.push(column);
											}
										});
										parItem.children.map((innerItem, innerIndex) => {
											if (innerItem.title == params[key][1]) {
												if(innerItem.title.includes('#')) innerItem.title = '';
												innerItem.children.push(obj);
											}
										});
									}
								}
							});
						} else {
							if (index == 0) {
								typeColumn.title = item;
								typeColumn.children = [];
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]}`) {
										typeColumn.children.push(column);
									}
								});
							} else if (index == 1) {
								const obj = {}
								obj.title = item;
								obj.children = [];
		
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
										obj.children.push(column);
									}
								});
								typeColumn.children.push(obj);
							} else if (index == 2) {
								const obj = {}
								obj.title = item;
								obj.children = [];
		
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
										obj.children.push(column);
									}
								});
								typeColumn.children.map((innerItem, innerIndex) => {
									if (innerItem.title == params[key][1]) {
										if(innerItem.title.includes('#')) innerItem.title = '';
										innerItem.children.push(obj);
									}
								})
							}
						}
					} else {
						if (index == 0) {
							typeColumn.title = item;
							typeColumn.children = [];
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]}`) {
									typeColumn.children.push(column);
								}
							});
						} else if (index == 1) {
							const obj = {}
							obj.title = item;
							obj.children = [];
	
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
									obj.children.push(column);
								}
							});
							typeColumn.children.push(obj);
						} else if (index == 2) {
							const obj = {}
							obj.title = item;
							obj.children = [];
	
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
									obj.children.push(column);
								}
							});
							typeColumn.children.map((innerItem, innerIndex) => {
								if (innerItem.title == params[key][1]) {
									if(innerItem.title.includes('#')) innerItem.title = '';
									innerItem.children.push(obj);
								}
							})
						}
					}
				});

				!isExist && parentColumn.push(typeColumn);
			}
		}

		columns.map((item, index) => {
			if (item.visitTypeNameShow) {
				if (parentColumn.length > 0) {
					parentColumn.map((innerItem, innerIndex) => {
						if (item.visitTypeNameShow.split(',')[0] == innerItem.title) {
							columns[index] = parentColumn[innerIndex];
							parentColumn.splice(innerIndex, 1);
						}
					});
				} else {
					if (item.visitTypeNameShow) {
						delete columns[index];
					}
				}
			}
		});

		columns.map((item, index) => { 
			if (item.visitTypeNameShow) {
				delete columns[index];
			}
		});
		return { columns };
	}

	handleTableChangePre = (params) => {
		const { dataSource } = this.state;
		if (dataSource.some(i => i.isSave == true)) {
			Modal.confirm({
				title: '数据尚未保存，确定不做保存继续当前操作吗？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => this.props.handleTableChange(params),
			});
		} else {
			this.props.handleTableChange(params);
		}
	}

	convertDataSource = (dataSource, tableColumns = []) => {
		let key = 0;
		const { criteriaDefineId } = this.state;
		const { controllers, typeName } = this.props;
		const data = dataSource.map(rowData => {
			const rowDataKey = Object.entries(rowData);
			let rowNum = 1;
			rowDataKey.map(rowKeyValue => {
				if (Array.isArray(rowKeyValue[1])) {
					const fieldArray = rowKeyValue[1];
					fieldArray.map((field => {
						rowNum = field.rowNum;
						const newKeyName = rowKeyValue[0] + "_" + rowNum;
						rowData[newKeyName] = { ...field };
						// 填写控制
						if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
							const controll = controllers.find(controll => controll.controlled == rowKeyValue[0]);
							const controller = controll ? controll.controller : '';
							const controllValue = controll ? controll.value : '';
							const array = rowDataKey.find(rowData => rowData[0] == controller);
							const result = array ? array[1][rowNum - 1] ? array[1][rowNum - 1].value : '' : '';
							if (controll) {
								if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
									rowData[newKeyName]['editable'] = (!!result && array[1][rowNum - 1].editable != 0) ? 1 : 0; 
								} else {
									rowData[newKeyName]['editable'] = ((result === controllValue) && array[1][rowNum - 1].editable != 0) ? 1 : 0;
								}
							}
						}
					}));
				}
			});
			// 填写控制
			rowNum = 1;
			if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
				// 筛选出没数据的指标
				const columns = tableColumns.filter(item => !rowDataKey.find(rowKeyValue => rowKeyValue[0] == item.moduleDefineCode && rowKeyValue[1].length));
				columns.forEach(item => {
					const controll = controllers.find(controll => controll.controlled == item.moduleDefineCode);
					const controller = controll ? controll.controller : '';
					const controllValue = controll ? controll.value : '';
					const array = rowDataKey.find(rowData => rowData[0] == controller);
					const result = array ? array[1][rowNum - 1] ? array[1][rowNum - 1].value : '' : '';
					let editable;
					if (controll) {
						if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
							editable = (!!result && array[1][rowNum - 1].editable != 0) ? 1 : 0;
						} else {
							editable = ((result === controllValue) && array[1][rowNum - 1].editable != 0) ? 1 : 0;
						}
					} else {
						editable = 1;
					}
					rowData[item.moduleDefineCode + '_' + rowNum] = {
						rowNum,
						editable,
					};
				});
			}

			const moduleDefine = tableColumns.find(column => column.moduleDefineName == '录入者') || {};
			const { moduleDefineCode } = moduleDefine;
			if (moduleDefineCode && !rowData[moduleDefineCode]) {
				rowData[moduleDefineCode] = {
					comment: "",
					criteriaDefineId,
					value: sessionStorage.userName,
					moduleDefineCode,
					rowNum,
				};
			}
			rowData["key"] = rowData.key;
			key++;
			rowData["isSave"] = false;
			let childRowNum = 1;
			if (rowData.children && rowData.children.length > 0) {
				rowData.children.map(value => {
					const rowChildKey = Object.entries(value);
					rowChildKey.map(childKeyValue => {
						if (Array.isArray(childKeyValue[1])) {
							const fieldArray = childKeyValue[1];
							fieldArray.map((field => {
								childRowNum = field.rowNum;
								const newKeyName = childKeyValue[0] + "_" + field.rowNum;
								const newFieldValue = { ...field };
								value[newKeyName] = newFieldValue;
								// 填写控制
								if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
									const controll = controllers.find(controll => controll.controlled == childKeyValue[0]);
									const controller = controll ? controll.controller : '';
									const controllValue = controll ? controll.value : '';
									const array = rowChildKey.find(rowChild => rowChild[0] == controller);
									const result = array ? array[1][childRowNum - 1] ? array[1][childRowNum - 1].value : '' : '';
									if (controll) {
										if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
											value[newKeyName]['editable'] = (controll && !!result && array[1][childRowNum - 1].editable != 0) ? 1 : 0;
										} else {
											value[newKeyName]['editable'] = (controll && (result === controllValue) && array[1][childRowNum - 1].editable != 0) ? 1 : 0;
										}
									}
								}
							}));
						}
					});
					childRowNum = 1;
					if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
						const columns = tableColumns.filter(item => !rowChildKey.find(childKeyValue => childKeyValue[0] == item.moduleDefineCode && childKeyValue[1].length));
						// 填写控制
						columns.forEach(item => {
							const controll = controllers.find(controll => controll.controlled == item.moduleDefineCode);
							const controller = controll ? controll.controller : '';
							const controllValue = controll ? controll.value : '';
							const array = rowChildKey.find(rowChild => rowChild[0] == controller);
							const result = array ? array[1][childRowNum - 1] ? array[1][childRowNum - 1].value : '' : '';
							let editable;
							if (controll) {
								if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
									editable = (controll && !!result && array[1][childRowNum - 1].editable != 0) ? 1 : 0;
								} else {
									editable = (controll && (result === controllValue) && array[1][childRowNum - 1].editable != 0) ? 1 : 0;
								}
							} else {
								editable = 1;
							}
							rowData[item.moduleDefineCode + '_' + childRowNum] = {
								rowNum: childRowNum,
								editable,
							};
						});
					}
					if (moduleDefineCode && !value[moduleDefineCode]) {
						rowData[moduleDefineCode] = {
							comment: "",
							criteriaDefineId,
							value: sessionStorage.userName,
							moduleDefineCode,
							rowNum: childRowNum,
						};
					}
					value["key"] = value.key;
					key++;
					value["isSave"] = false;
				});
			}
			return rowData;
		});
		this.setState({ count: key });
		return { data };
	}

	getFatherIndex = (record) => {
		const dataSource = this.state.dataSource;
		let dataIndex;
		dataSource.map((father, fatherIndex) => {
			if (father['children']) {
				father['children'].map((child, childIndex) => {
					if (child.key == record.key) {
						dataIndex = fatherIndex;
					}
				})
			}
		})
		return dataIndex;
	}

	onCellChange = (index, key, criteriaDefineId, special, record, tableColumn) => {
		return (value, type) => {
			if (type == 'reRender') {
				this.setState({ dataSource: [...this.state.dataSource] });
				return;
			}
			if (tableColumn.moduleDefineName == '访视分组') {
				const { currentGroup: { visitGroupingId } } = this.props;
				if (value != undefined && visitGroupingId != value) {
					this.setState({
						needTransfer: true,
						otherVisitGroupingId: value,
					}, () => {
						this.verify(record);
					})
				}
			}
			if (special && type !== "comment") {
				this.getVisitDate(value, key, index, criteriaDefineId, tableColumn, record);
			}
			const dataSource = [...this.state.dataSource];

			const { controllers, tableColumns, typeName } = this.props;
			
			if ((record && record.child) !== 1 || record.child == undefined) {
				if (!dataSource[index][key] || (dataSource[index][key] && !dataSource[index][key]['moduleDefineCode'])) {
					this.initValue(dataSource[index], key, tableColumn);
					if (type !== "comment") {
						if (value !== "") {
							dataSource[index][key]['value'] = value;
						}
					}
				}
				this.loopController(typeName, dataSource[index], key, value, tableColumns, controllers);
				dataSource[index][key][type] = value;
				dataSource[index]["isSave"] = true;
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (dataSource[dataIndex] && dataSource[dataIndex]['children']) {
					if (!dataSource[dataIndex]['children'][index][key] || (dataSource[dataIndex]['children'][index][key] && !dataSource[dataIndex]['children'][index][key]['moduleDefineCode'])) {
						this.initValue(dataSource[dataIndex]['children'][index], key, tableColumn);
						if (type !== "comment") {
							if (value !== "") {
								dataSource[dataIndex]['children'][index][key]['value'] = value;
							}
						}
					}
				}
				this.loopController(typeName, dataSource[dataIndex]['children'][index], key, value, tableColumns, controllers);
				dataSource[dataIndex]['children'][index][key][type] = value;
				dataSource[dataIndex]['children'][index]["isSave"] = true;
			}
			this.setState({ dataSource });
		};
	}

	initValue = (obj, code, tableColumn) => {
		const { typeName } = this.props;
		obj[code] = {
			comment: "",
			criteriaDefineId: tableColumn.criteriaDefineId,
			editable: 1,
			moduleDefineCode: tableColumn.moduleDefineCode,
			rowNum: tableColumn.rowNum,
		};
		if (typeName !== 'Type_Visit') {
			obj[code]['realRowNum'] = obj['rowNum'];
		}
	}

	loopController = (typeName, obj, key, value, tableColumns, controllers) => {
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
			const suffix = key.slice(-2);
			const code = key.slice(0, key.length - 2);
			// 查询是否是控制列表中
			controllers.forEach(item => {
				if (item.controller == code) {
					const controlledKey = item.controlled + suffix;
					if (item.oper == 'EQ') {
						//	被控制方存在
						if (obj[controlledKey] && obj[controlledKey].moduleDefineCode) {
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态') {
								editable = !!value ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态' && value && !obj[controlledKey].value) {
									obj[controlledKey].value = '试验进行中';
								}
								if (item.controllerName == '患者状态' && item.controlledName == '是否最后一个病例完成试验' && value == '完成整个研究') {
									obj[controlledKey]['value'] = '否';
								} else if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						} else {
							// 不存在
							const controllColumn = tableColumns.find(column => column.moduleDefineCode == item.controlled) || {};
							this.initValue(obj, controlledKey, controllColumn);
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态') {
								editable = !!value ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态' && value && !obj[controlledKey].value) {
									obj[controlledKey].value = '试验进行中';
								}
								if (item.controllerName == '患者状态' && item.controlledName == '是否最后一个病例完成试验' && value == '完成整个研究') {
									obj[controlledKey]['value'] = '否';
								} else if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						}
					}
					// 查询被控制方是否在控制列表中作为控制方存在
					const newValue = obj[controlledKey]['value'] || '';
					this.loopController(typeName, obj, controlledKey, newValue, tableColumns, controllers);
				}
			});
		}
	}

	onPatientCodeChange = (index, key, criteriaDefineId, record) => {
		return (value, type) => {
			const { dataSource } = this.state;
			const { controllers, tableColumns, typeName } = this.props;
			if (record && record.child !== 1) {
				const rowObj = dataSource[index];
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					if (value.patientId) {
						rowObj.patientUserId = value.patientId;
					}
				}
				rowObj.newPatientUserId = value.patientId;
				Object.keys(value).forEach(item => {
					tableColumns.forEach(column => {
						if (column.moduleDefineCode == item) {
							const currentCode = `${item}_${rowObj.rowNum || 1}`;
							if (rowObj[currentCode]) {
								// const hasValue = !!rowObj[currentCode].value;
								rowObj[currentCode] = {
									...rowObj[currentCode],
									value: value[item],
									moduleDefineCode: item,
									criteriaDefineId: column.criteriaDefineId,
								};
								this.loopController(typeName, rowObj, currentCode, value[item], tableColumns, controllers);
							} else {
								rowObj[currentCode] = {
									comment: "",
									criteriaDefineId: column.criteriaDefineId,
									value: value[item],
									moduleDefineCode: item,
									rowNum: rowObj.rowNum,
								};
								this.loopController(typeName, rowObj, currentCode, value[item], tableColumns, controllers);
							}
						}
					});
				});
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					if (value.patientId) {
						dataSource[dataIndex]['children'][index].patientUserId = value.patientId;
					}
				}
				dataSource[dataIndex]['children'][index].newPatientUserId = dataSource[dataIndex]['children'][index].patientUserId;
			}
			this.setState({ dataSource });
		};
	}

	handleAdd = () => {
		const { typeName } = this.props;
		if (typeName == 'Type_Filter') {
			this.checkCanAddFilterRecord();
		} else {
			this.handleAddRecord();
		}
	}

	handleAddRecord = () => {
		const { controllers, typeName, isUnBlind, relateCenter } = this.props;
		const { count, dataSource, moduleDefineCode, criteriaDefineId, tableColumns } = this.state;
		const newData = {
			key: count + "new5efk",
			patientUserId: -1,
			isSave: true,
			[moduleDefineCode + '_1']: {
				comment: "",
				criteriaDefineId,
				value: sessionStorage.userName,
				moduleDefineCode,
				rowNum: 1,
			},
			editable: 1
		};
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
			tableColumns.forEach(item => {
				if (item.moduleDefineCode != moduleDefineCode) {
					const isControlled = controllers.some(controll => controll.controlled == item.moduleDefineCode);
					const setting = {};
					if (isUnBlind && !relateCenter && item.moduleDefineName === '患者状态') {
						setting.value = '试验进行中';
						setting.criteriaDefineId = item.criteriaDefineId;
						setting.moduleDefineCode = item.moduleDefineCode;
					}
					newData[item.moduleDefineCode + '_1'] = {
						...setting,
						rowNum: 1,
						editable: isControlled ? 0 : 1,
					};
				}
			});
		}
		this.setState({
			dataSource: [newData, ...dataSource],
			count: count + 1,
		}, () => {
			const { tableColumns } = this.state;
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns });
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ dataSource: [], columns: [], count: 0, pagination: this.props.pagination }, () => {
			const { tableColumns, tableDatas, loading } = nextProps;
			this.setState({
				dataSource: this.convertDataSource(tableDatas, tableColumns).data,
				tableColumns,
				loading,
			}, () => {
				const { columns } = this.convertColumns(tableColumns);
				this.setState({ columns })
			});
		});
		 this.queryInvStatus();
	}

	componentDidMount () {
		const { tableColumns, tableDatas, loading, pagination } = this.props;
		this.queryEffectiveDate();
		this.queryInvCreateTimeVisit();
		this.setState({
			dataSource: this.convertDataSource(tableDatas, tableColumns).data,
			tableColumns,
			loading,
			pagination,
		}, () => {
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns })
		});
		
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.dataSource !== this.state.dataSource) {
			this.calculateHeight();
		}
	}
	
	 queryInvStatus = () => {
        const { invId } = sessionStorage;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvStatus,
            data: {
                investigationId: invId,
                publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({  isFilterProcess: res.isFilterProcess });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

	showCrfAgain = (record) => {
		this.crfAgainRef.show(record);
	}

	showCrfHistory = (patientUserId) => {
		this.crfHistoryRef.show(patientUserId);
	}

	handleExpand = () => {
		this.calculateHeight();
	}

	calculateHeight = () => {
		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(() => {
			const table = jquery('.ant-table-scroll .ant-table-body .ant-table-fixed tbody tr');
			const table_right = jquery('.ant-table-fixed-right .ant-table-body-outer .ant-table-fixed tbody tr');
			table.each((index, item) => {
				const height = jquery(item).height();
				const right = jquery(table_right).eq(index);
				if (height !== jquery(right).height()) {
					jquery(table_right).eq(index).height(height);
				}
			});
		}, 100);
	}

	render() {
		const { maxDate, loadData, controllers, typeName, currentGroup: { visitGroupingId }, canEditByInvStatus, pagination, sortParams } = this.props;
		const { dataSource, columns, loading, tableColumns } = this.state;
		return (
			<div>
				<TableC
					data={dataSource}
					onChange={this.handleTableChangePre}
					pagination={pagination}
					sortParams={sortParams}
					columns={columns}
					loading={loading}
					scrollY={500}
					rowKey='key'
					className='table-cell-row crf-table'
					onExpand={this.handleExpand}
				/>
				<ConfigColumn
					loadData={loadData}
					typeName={typeName}
                    ref={el => this.configColumnRef = el}
                />
				<CrfAgain
					maxDate={maxDate}
					loadData={loadData}
					typeName={typeName}
					controllers={controllers}
					tableColumns={tableColumns}
					visitGroupingId={visitGroupingId}
					canEditByInvStatus={canEditByInvStatus}
					ref={el => this.crfAgainRef = el}
				/>
				<CrfHistory
					loadData={loadData}
					typeName={typeName}
					canEditByInvStatus={canEditByInvStatus}
					ref={el => this.crfHistoryRef = el}
					visitGroupingId={visitGroupingId}
				/>
			</div>
		);
	}
}

export default CrfTable;


// WEBPACK FOOTER //
// ./src/components/execute/CrfTable.js